import { SORTING_DIRECTION } from 'src/constants/main';
import { IUserV4 } from 'src/types/user';
import {
  IUsersFilters,
  IUserValidation,
  USERS_SORT_COLUMN,
} from 'src/view/screens/SettingsScreen/screens/General/ManageUsers/screens/AllUsers/types/users';

export const defaultUser: IUserV4 = {
  id: 0,
  first_name: '',
  last_name: '',
  username: '',
  email: '',
  mobile: undefined,
  status: 0,
  is_delete: 0,
  created_at: new Date(),
  updated_at: new Date(),
  roles: [],
  branches: [],
  franchises: [],
};

export const defaultUsersFilters: IUsersFilters = {
  search: '',
  status: undefined,
  roles: undefined,
  perPage: undefined,
  sortField: USERS_SORT_COLUMN.NAME,
  sortDir: SORTING_DIRECTION.ASCENDING,
};

export const defaultUserValidation: IUserValidation = {
  status: {
    state: true,
  },
  role: {
    state: true,
  },
  branches: {
    state: true,
  },
  franchises: {
    state: true,
  },
  name: {
    state: true,
  },
  username: {
    state: true,
  },
  email: {
    state: true,
  },
  password: {
    state: true,
  },
  mobile: {
    state: true,
  },
};
